import React from "react";

interface VersionProps {
  version: string;
}

function Version({ version }: VersionProps) {
  return (
    <div className="fixed bottom-0 left-[10px] flex gap-2 text-[15px]">
      <span className="text-[#0099FE]">{version}</span>
      <span className="text-yellow-500 ">beta</span>
    </div>
  );
}

export default Version;
